import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AddQuestion = () => {
  const [questionText, setQuestionText] = useState('');
  const [options, setOptions] = useState([
    { optionText: '', isCorrect: false },
    { optionText: '', isCorrect: false },
    { optionText: '', isCorrect: false },
    { optionText: '', isCorrect: false },
  ]);
  const [categoryIds, setCategoryIds] = useState([101]); // Example category ID

  useEffect(() => {
    // Fetch existing assignments when component mounts
    const fetchAssignments = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/questions/assignments`);
        const assignments = response.data.$values;
        console.log('Fetched assignments:', assignments);

        // Update the state with the fetched assignments
        if (assignments && assignments.length > 0) {
          const assignedOptions = options.map((option, index) => {
            const isCorrect = assignments.some(assignment => 
              assignment.options.$values.some(o => o.optionText === option.optionText && o.isCorrect)
            );
            return { ...option, isCorrect };
          });
          console.log('Assigned options:', assignedOptions);
          setOptions(assignedOptions);
        }
      } catch (error) {
        console.error('Error fetching assignments:', error.response ? error.response.data : error.message);
      }
    };

    fetchAssignments();
  }, []);

  const handleOptionChange = (index, field, value) => {
    const newOptions = [...options];
    newOptions[index][field] = value;
    setOptions(newOptions);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      questionText,
      categoryIds,
      options: options.map((option, index) => ({
        optionId: index + 1, // Assuming optionId is not required and will be generated by the backend
        optionText: option.optionText,
        isCorrect: option.isCorrect,
      })),
    };
    console.log('Payload:', payload);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/questions`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'accept': 'text/plain'
        }
      });
      alert('Question created successfully');
      console.log('Response:', response.data);

      // Optionally, clear the form after successful submission
      setQuestionText('');
      setOptions([
        { optionText: '', isCorrect: false },
        { optionText: '', isCorrect: false },
        { optionText: '', isCorrect: false },
        { optionText: '', isCorrect: false },
      ]);
    } catch (error) {
      console.error('Error creating question:', error.response ? error.response.data : error.message);
      alert('Failed to create question');
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-6">Add New Question</h1>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700">Question Text:</label>
          <input
            type="text"
            value={questionText}
            onChange={(e) => setQuestionText(e.target.value)}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
            required
          />
        </div>
        {options.map((option, index) => (
          <div key={index} className="mb-4">
            <label className="block text-gray-700">Option {index + 1}:</label>
            <input
              type="text"
              value={option.optionText}
              onChange={(e) => handleOptionChange(index, 'optionText', e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
              required
            />
            <label className="inline-flex items-center mt-2">
              <input
                type="checkbox"
                checked={option.isCorrect}
                onChange={(e) => handleOptionChange(index, 'isCorrect', e.target.checked)}
                className="form-checkbox"
              />
              <span className="ml-2">Is Correct</span>
            </label>
          </div>
        ))}
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
          Create Question
        </button>
      </form>
    </div>
  );
};

export default AddQuestion;
